<template>
    <div class="support">
        support
    </div>
</template>
<script>
export default {
    name:'support'
}
</script>
<style lang="">
    
</style>